module.exports = __webpack_public_path__ + "img/aliminigame.2d03acdb.png";